/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualKeyPublicBase58: core.serialization.ObjectSchema<
    serializers.EqualKeyPublicBase58.Raw,
    Truvity.EqualKeyPublicBase58
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace EqualKeyPublicBase58 {
    export interface Raw {
        value: string;
    }
}
